<template>
  <div class="card modal-card" v-if="ligneCommandeTemp && ligneCommandeTemp.lignesRemise">
    <div class="modal-card-body">
      <div class="card-content is-paddingless">
        <div class="mgb-50px">
          <h1 class="title is-size-3 has-text-centered">
            {{$t('editionRemise.title')}}
          </h1>
        </div>
        <qd-collapse :open="modePrixNetFace" v-if="seeModePrixNetFace" class="card-remise">
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
            role="button">
            <p class="card-header-title has-text-default">
              {{ $t('editionRemise.modePrixNetFace.title') }}
            </p>
            <a class="card-header-icon">
              <b-icon icon="chevron-right" class="animationChevron"
                      :class="{'rotationChevronOuvertureMenu': props.open }">
              </b-icon>
            </a>
          </div>
          <div class="card-content">
            <div class="columns is-multiline content">
              <b-field :label="$t('editionRemise.modePrixNetFace.libelle')"
                       class="column is-8 mgb-0">
                <b-input v-model="remisePrixNetFaceAAjouter.libelle"></b-input>
              </b-field>
              <b-field :label="$t('editionRemise.modePrixNetFace.facePropose')"
                       class="column is-4 mgb-0">
                <b-input :value="qteFacesPrevues" disabled></b-input>
              </b-field>
              <b-field :label="$t('editionRemise.modePrixNetFace.prixTotal')"
                       class="column is-3">
                <input-currency v-model="ligneCommandeTemp.totalHt" disabled></input-currency>
              </b-field>
              <b-field :label="$t('editionRemise.modePrixNetFace.prixNetFace')"
                       class="column is-3">
                <input-currency v-model="getPrixNetFaceActuel" disabled></input-currency>
              </b-field>
              <b-field :label="$t('editionRemise.modePrixNetFace.prixNetFaceSouhaite')"
                       class="column is-3">
                <input-currency v-model="prixNetFaceSouhaite"></input-currency>
              </b-field>
              <b-field class="column is-3 control bfieldWhitoutLabel">
                <a class="is-addOrEdit button is-fullwidth"
                   @click="ajouterRemiseWithPrixNetFace()">
                  {{ $t('editionRemise.modePrixNetFace.actions.add') }}
                </a>
              </b-field>
            </div>
          </div>
        </qd-collapse>
        <qd-collapse class="card-remise" :open="modeAAtteindreOpen"
                    :class="{'mgt-20px' : isReseauTempo}" v-if="!isProduitPresse">
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
            role="button">
            <p class="card-header-title has-text-default">
              {{ $t('editionRemise.modeAAtteindre') }}
            </p>
            <a class="card-header-icon">
              <b-icon icon="chevron-right" class="animationChevron"
                      :class="{'rotationChevronOuvertureMenu': props.open }">
              </b-icon>
            </a>
          </div>
          <div class="card-content">
            <mode-a-atteindre :ligneCommandeTemp="ligneCommandeTemp"></mode-a-atteindre>
          </div>
        </qd-collapse>
        <qd-collapse class="card-remise mgt-20px">
          <div class="card-header">
            <p class="card-header-title has-text-default">
              {{ $t('editionRemise.modeManuel') }}
            </p>
          </div>
          <div class="card-content">
            <mode-manuel-remise-perso
              :ligne-commande-temp="ligneCommandeTemp"
              :ligneRegroupement="ligneRegroupement"
              @setRemiseRegie="$emit('setRemiseRegie', $event)"
              :displayMontant="true"
              :disableCumuleMode="isProduitPresse"
              :cgvs="cgvs"/>
          </div>
        </qd-collapse>
      </div>
      <footer>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="cancelRemise()">
            {{ $t('editionRemise.actions.revert')}}
          </button>
          <button
            class="button is-addOrEdit has-text-centered button-modal"
            @click="validerRemise()" >
            {{ $t('editionRemise.actions.validate')}}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import calculLignesRemise from '@/services/devisCommandes/calcul/calculLignesRemise';
import remiseValidation from '@/services/devisCommandes/validation/addRemiseValidation';
import genererLigneRemise from '@/services/devisCommandes/genererLigneRemise';
import * as remiseF2B from '@/services/devisCommandes/traductionRemiseBackFront';
import inputCurrency from '@/components/general/inputCurrency';
import * as devisConf from '@/configuration/devisConf';
import decimalsFormater from '@/services/general/decimalsFormater';
import findPourcentageRemise from '@/services/devisCommandes/findPourcentageRemise';
import messageErreur from '@/services/general/messageErreur';
import modeManuelRemisePerso from '@/components/devisCommandeFacture/remise/modeManuelRemisePerso';
import {
  CATEGORIE_LOCATION,
  CATEGORIE_PRESSE,
  CATEGORIE_SPONSORING,
  CATEGORIE_SALON,
  CATEGORIE_AUTRE,
} from '@/configuration/catalogue/produitConf';
import modeAAtteindre from '@/components/devisCommandeFacture/remise/modeAAtteindre';

export default {
  name: 'lignes-remise',
  props: {
    ligneCommande: {
      required: true,
      type: Object,
    },
    ligneRegroupement: {
      required: false,
      type: Object,
      default: null,
    },
    isReseauTempo: {
      required: true,
      type: Boolean,
    },
    qteFacesPrevues: {
      required: false,
      default: 0,
      type: Number,
    },
    cgvs: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    inputCurrency,
    modeManuelRemisePerso,
    modeAAtteindre,
  },
  data() {
    return {
      remiseDisplayAAtteindreMode: '0 %',
      prixAAtteindre: null,
      prixNetFaceSouhaite: null,
      errorInsert: false,
      modeAAtteindreOpen: false,
      modePrixNetFace: false,
      remiseAAjouter: genererLigneRemise(),
      remiseAAtteindreAAjouter: genererLigneRemise(),
      remisePrixNetFaceAAjouter: genererLigneRemise(),
      ligneCommandeTemp: null,
      messages: [],
      decimalsFormaterFct: decimalsFormater,
    };
  },
  computed: {
    isProduitPresse() {
      return this.ligneRegroupement && this.ligneRegroupement.produit
        && this.ligneRegroupement.produit.cgvs && this.ligneRegroupement.produit.cgvs.length > 0
        && (this.ligneRegroupement.typeProduit === CATEGORIE_PRESSE
        || this.ligneRegroupement.typeProduit === CATEGORIE_SPONSORING
        || this.ligneRegroupement.typeProduit === CATEGORIE_SALON
        || this.ligneRegroupement.typeProduit === CATEGORIE_AUTRE);
    },
    getPrixNetFaceActuel() {
      if (this.qteFacesPrevues < 1) return 0;
      return this.ligneCommandeTemp.totalHt / this.qteFacesPrevues;
    },
    seeModePrixNetFace() {
      return this.isReseauTempo && this.ligneCommandeTemp.typeProduit === CATEGORIE_LOCATION;
    },
    columns() {
      return ['libelle', 'remise', 'type', 'montant', 'supprimer'];
    },
    findOrdre() {
      if (this.ligneCommandeTemp.lignesRemise.length === 0) {
        return 0;
      }
      const ordres = this.ligneCommandeTemp.lignesRemise.map((r) => {
        return r.ordre;
      });
      return Math.max(...ordres) + 1;
    },
    getLabelDiscoutOrAugmentation() {
      if (this.remiseAAtteindreAAjouter.typeRemise
        === devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE) {
        return this.$i18n.t('editionRemise.discount');
      }
      return this.$i18n.t('editionRemise.majoration');
    },
  },
  methods: {
    changeDisplayRemise() {
      findPourcentageRemise(
        this.remiseAAtteindreAAjouter,
        this.prixAAtteindre,
        this.ligneCommandeTemp.totalHt,
      );
      const remise = decimalsFormater(this.remiseAAtteindreAAjouter.remise);
      if (this.remiseAAtteindreAAjouter.typeRemise
        === devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE) {
        this.remiseDisplayAAtteindreMode = (remise * -1) + ' %';
      } else this.remiseDisplayAAtteindreMode = remise + ' %';
    },
    ajouterRemiseWithPrixNetFace() {
      if (this.prixNetFaceSouhaite === null) {
        messageErreur(this.$i18n, this.$i18n.t('editionRemise.errors.prixNetFaceSouhaiteNull'));
        return;
      }
      const prixAAtteindre = this.prixNetFaceSouhaite * this.qteFacesPrevues;
      findPourcentageRemise(
        this.remisePrixNetFaceAAjouter,
        prixAAtteindre,
        this.ligneCommandeTemp.totalHt,
      );
      this.ajouterRemise(this.remisePrixNetFaceAAjouter, false, true);
    },
    ajouterRemise(remiseAAjouter, modeAAtteindre, modePrixNetFace) {
      this.messages = [];
      remiseAAjouter.montant = 0;
      if (this.prixAAtteindre === null && modeAAtteindre) {
        messageErreur(this.$i18n, this.$i18n.t('editionRemise.errors.prixAAtteindreNull'));
        return;
      }
      if ((modeAAtteindre || modePrixNetFace) && remiseAAjouter.remise === 0) {
        messageErreur(this.$i18n, this.$i18n.t('editionRemise.remisePrixDepartZero'));
        if (modeAAtteindre) this.prixAAtteindre = null;
        else this.prixNetFaceSouhaite = null;
        return;
      }
      remiseValidation(remiseAAjouter, this.messages);
      this.errorInsert = this.messages.length > 0;
      if (this.errorInsert) {
        return;
      }
      this.currentOrdre = this.findOrdre;
      remiseAAjouter.ordre = this.currentOrdre;
      const realRemise = cloneDeep(remiseAAjouter);
      remiseF2B.fromTypeRemiseFront(realRemise, remiseAAjouter.typeRemise);
      remiseF2B.fromMontantRemiseFront(realRemise, remiseAAjouter.typeRemise,
        remiseAAjouter.remise);
      this.ligneCommandeTemp.lignesRemise.push(realRemise);
      calculLignesRemise(this.ligneCommandeTemp);
      this.remiseAAjouter = genererLigneRemise();
      if (modeAAtteindre) {
        this.prixAAtteindre = null;
        this.remiseDisplayAAtteindreMode = '0 %';
      } else if (modePrixNetFace) this.prixNetFaceSouhaite = null;
    },
    validerRemise() {
      this.$emit('validationRemise', this.ligneCommandeTemp);
      this.$emit('setRemiseRegie', 'non necessaire normalement');
    },
    cancelRemise() {
      this.$emit('cancelRemise');
    },
    suppression(index) {
      this.ligneCommandeTemp.lignesRemise.splice(index, 1);
      calculLignesRemise(this.ligneCommandeTemp);
    },
  },
  mounted() {
    this.ligneCommandeTemp = cloneDeep(this.ligneCommande);
    this.ligneCommandeTemp.remise = 0;
    calculLignesRemise(this.ligneCommandeTemp);
    if (!this.ligneCommandeTemp.totalHt) this.ligneCommandeTemp.totalHt = 0;
    if (!this.ligneCommandeTemp.totalAvantRemise) this.ligneCommandeTemp.totalAvantRemise = 0;
  },
};
</script>
